import React, { useState } from 'react'
import ValidationConstant from '../../../../../services/validator/validation.constant';
import FormValidatorService from '../../../../../services/validator/form-validator.service';
import toast from "react-hot-toast";
const PatientTypeForm = (props) => {
    const [inputData, setInputData] = useState(props.initialData || { appointmentBorderColor: '#000000' });
    const [isDefault, setIsDefault] = inputData.isDefault ? useState(Boolean(inputData.isDefault)) : useState(false)
    const [errors, setErrors] = useState({})
    const required = ['patientType', 'appointmentBorderColor']
    const PatientTypeConfig = {
        config: {
            'PatientType': {
                required: { name: ValidationConstant.patient.type.add.type.name },
                maxlength: {
                    name: ValidationConstant.patient.type.add.type.name,
                    max: ValidationConstant.patient.type.add.type.maxLength.toString()
                },
                minlength: {
                    name: ValidationConstant.patient.type.add.type.name,
                    min: ValidationConstant.patient.type.add.type.minLength.toString()
                },
            },
            'AppointmentBorderColor': {
                required: { name: ValidationConstant.patient.type.add.color.name },
            },
        },
        'PatientType': ['', []],
        'AppointmentBorderColor': ['', []],
    }

    const inputChange = (e) => {
        if (e.target.name === 'isDefault') {
            let newStateObject = { ...inputData };
            newStateObject[e.target.name] = e.target.checked ? true : false;
            setInputData(newStateObject);
            setIsDefault(e.target.checked);
        } else {
            let newStateObject = { ...inputData };
            newStateObject[e.target.name] = e.target.value;
            setInputData(newStateObject);
        }
        setErrors(FormValidatorService.setErrors(e, errors, PatientTypeConfig.config))
    };

    return (
        <>
            <div className="ui container">
                <div className=" row d-flex align-items-start">
                    <div className="col-12  field">
                        <label className="d-flex justify-content-between align-items-center">
                            <span>
                                Patient Type <span style={{ color: 'red' }}>*</span>
                            </span>
                            <div className="form-check form-check-inline" style={{ display: 'flex', alignItems: 'center' }}>
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={isDefault}
                                    name="isDefault"
                                    onChange={e => inputChange(e)}
                                />
                                <label className="form-check-label ms-2">Set as Default</label>
                            </div>
                        </label>
                        <input type="text"
                            value={inputData.patientType}
                            onChange={e => {
                                e.preventDefault();
                                inputChange(e)
                            }}
                            name="patientType"
                            placeholder="Patient Type"
                            required
                        />
                        <span className="error-message">{errors?.patientType}</span>
                    </div>
                    <div className="col-12 required field">
                        <label>Appt. Border Color</label>
                        <input type="color" className="form-control form-control-color" name='appointmentBorderColor' id="appointmentBorderColor" value={inputData.appointmentBorderColor} onChange={e => { e.preventDefault(); inputChange(e) }} title="Select Appt. Border Color" required />
                        <span className="error-message">{errors?.appointmentBorderColor}</span>
                    </div>
                </div>
            </div>

            <div className='row mt-3 d-flex justify-content-between modal-button-bar'>
                <div className='col-auto'>
                    <button className="btn btn-primary"
                        onClick={(e) => {
                            e.preventDefault();
                            if (!FormValidatorService.checkForm(errors, inputData, required)) {
                                toast.error("Please make sure the form is complete")
                            }
                            else {
                                props.submitHandler(inputData);
                            }
                        }}
                    >{props.submitLabel || 'Save'}</button>
                </div>
                <div className='col-auto'>
                    <button className="btn btn-secondary" onClick={(e) => { e.preventDefault();; props.onClose() }}>Cancel</button>
                </div>
            </div>
        </>
    )
}

export default PatientTypeForm;